import { render, staticRenderFns } from "./HonorPanel.vue?vue&type=template&id=2d9cc238"
import script from "./HonorPanel.vue?vue&type=script&lang=js"
export * from "./HonorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports